import styled from '@emotion/styled';
import { colors } from '@modernanimal/common';

// Breakpoint logic
const minWidth = (breakpoint: number) => `@media (min-width: ${breakpoint}px)`;
const maxWidth = (breakpoint: number) => `@media (max-width: ${breakpoint}px)`;
const largeBreakpoint = 1023;
const largerBreakpoint = 1439;
const largerAndBelow = maxWidth(largerBreakpoint);
const largerAndUp = minWidth(largeBreakpoint + 1);
const responsiveStyles = (styleType: string, large: number, medium: number) => `
  ${largerAndUp} {
    ${styleType}: ${large}px;
  }
  ${largerAndBelow} {
    ${styleType}: ${medium}px;
  }
`;

const fontFamily = {
    base: 'FTRegolaNeue-Regular',
    baseMedium: 'FTRegolaNeue-Medium',
    baseBold: 'FTRegolaNeue-Bold',
};

const Body = styled.p`
    font-family: ${fontFamily.base};
    letter-spacing: 0;
    font-size: 16px;
    line-height: 24px;
    color: ${colors.GREY_1};
`;

const BodySmall = styled.p`
    ${Body}
    font-size: 14px;
    line-height: 20px;
`;

const BodyLarge = styled.p`
    ${Body}
    ${responsiveStyles('font-size', 18, 16)};
    ${responsiveStyles('line-height', 28, 24)};
`;

const LabelMedium = styled.label`
    font-family: ${fontFamily.baseMedium};
    font-size: 16px;
    ${responsiveStyles('line-height', 20, 24)};
    letter-spacing: 0;
    color: ${colors.GREY_1};
`;

const Heading06 = styled.h6`
    font-family: ${fontFamily.baseMedium};
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0;
    margin: 0;
    color: ${colors.GREY_1};
`;

const Heading05 = styled.h5`
    font-family: ${fontFamily.baseMedium};
    ${responsiveStyles('font-size', 24, 18)};
    ${responsiveStyles('line-height', 36, 18)};
    letter-spacing: -0.5%;
`;

const Heading04 = styled.h4`
    font-family: ${fontFamily.baseMedium};
    ${responsiveStyles('font-size', 28, 24)};
    ${responsiveStyles('line-height', 40, 36)};
    letter-spacing: -1%;
`;

const Heading03 = styled.h3`
    font-family: ${fontFamily.baseMedium};
    ${responsiveStyles('font-size', 32, 28)};
    ${responsiveStyles('line-height', 40, 36)};
    letter-spacing: -0.32px;
`;

const Heading04Rza = styled.h4`
    font-family: 'Rza';
    font-weight: 505;
    font-size: 24px;
    line-height: 36px;
    letter-spacing: -1%;
    margin: 0;
    color: ${colors.BROWN};
`;

const Fonts = {
    BodySmall,
    Body,
    BodyLarge,
    LabelMedium,
    Heading06,
    Heading05,
    Heading04,
    Heading03,
    Heading04Rza,
};

export default Fonts;
